// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function FieldValidationErrorWrapper(Props) {
  let field = Props.field;
  let className = Props.className;
  let children = Props.children;
  const text = field.valueForDisplay;
  let tmp;
  tmp = text.TAG === /* Ok */ 0 ? null : JsxRuntime.jsx("p", {
      children: text._0,
      className: "mt-1 text-red-500 text-sm"
    });
  return JsxRuntime.jsxs("div", {
    children: [
      children,
      tmp
    ],
    className: Cn.fromList({
      hd: Cn.take(className),
      tl: /* [] */ 0
    })
  });
}

const make = FieldValidationErrorWrapper;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
